import {Repository, createRepository} from '@/repositories/Base/Repository'

class SectorsRepository extends Repository {
    endpoint = 'sectors'

}

export default new SectorsRepository()

export const create = createRepository(SectorsRepository)
